import { createSlice } from "@reduxjs/toolkit";
import HatalikVerileriResponse from "src/models/GenelTanimlar/HastalikVerileriResponse";
import VwIstemPanelTanimTarifeDTO from "src/models/GenelTanimlar/VwIstemPanelTanimTarifeDTO";
import VwTestDetaybilgiDTO from "src/models/GenelTanimlar/VwTestDetaybilgiDTO";
import VwTestIstemdetaybilgiDTO from "src/models/GenelTanimlar/VwTestIstemdetaybilgiDTO";
import TestIstemdetaybilgiDTO from "src/models/HastaKayit/TestIstemdetaybilgiDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";
import { HastalikTanimApi } from "src/services/HastalikTanim/HastalikTanimApi";
import { RootState } from "src/store";

export class IstemDetayRequest extends VwTestDetaybilgiDTO {
    deger: string;
}

export interface IIstemPanelModel {
    data: Array<VwIstemPanelTanimTarifeDTO>;

    testIstemDetayBilgiList?: Array<IstemDetayRequest>;
    testIstemDetayBilgiEkleOpen?: boolean;
    selectedTest: any;
    istemEkleRowsStateTrigger: boolean;
    testDetayId: number,
    testDetayArray: Array<VwTestIstemdetaybilgiDTO>;
    testIstemDetayBilgiGuncelleOpen?: boolean;
}

const IstemPanelSlice = createSlice<IIstemPanelModel, MapReducerPayloads<IIstemPanelModel, {
    setState: IIstemPanelModel,
    setTestIstemDetayBilgiList?: Array<IstemDetayRequest>;
    setTestIstemDetayBilgiEkleOpen?: boolean;
    setSelectedTest: any;
    setIstemEkleRowsStateTrigger: boolean;
    setTestDetayId: number,
    setTestDetayArray?: Array<VwTestIstemdetaybilgiDTO>;
    setTestIstemDetayBilgiGuncelleOpen?: boolean;
}>>({
    name: 'IstemPanel',
    initialState: {
        data: [],
        testIstemDetayBilgiList: [],
        testIstemDetayBilgiEkleOpen: false,
        selectedTest: null,
        istemEkleRowsStateTrigger: false,
        testDetayId: 0,
        testDetayArray: [],
        testIstemDetayBilgiGuncelleOpen: false,
    },
    reducers: {
        setState: (state, action) => action.payload,
        setTestIstemDetayBilgiList: (state, action) => {
            state.testIstemDetayBilgiList = action.payload
        },
        setTestIstemDetayBilgiEkleOpen: (state, action) => {
            state.testIstemDetayBilgiEkleOpen = action.payload
        },
        setSelectedTest: (state, action) => {
            state.selectedTest = action.payload
        },
        setIstemEkleRowsStateTrigger: (state, action) => {
            state.istemEkleRowsStateTrigger = action.payload
        },
        setTestDetayId: (state, action) => {
            state.testDetayId = action.payload
        },
        setTestDetayArray: (state, action) => {
            state.testDetayArray = action.payload
        },
        setTestIstemDetayBilgiGuncelleOpen: (state, action) => {
            state.testIstemDetayBilgiGuncelleOpen = action.payload
        },
    },

})

export const getTestIstemDetayBilgiList = (state: RootState) => state.IsemPanel.testIstemDetayBilgiList;
export const getTestIstemDetayBilgiEkleOpen = (state: RootState) => state.IsemPanel.testIstemDetayBilgiEkleOpen;
export const getTestIstemDetayBilgiGuncelleOpen = (state: RootState) => state.IsemPanel.testIstemDetayBilgiGuncelleOpen;
export const getSelectedTest = (state: RootState) => state.IsemPanel.selectedTest;

export const {
    setTestIstemDetayBilgiList,
    setTestIstemDetayBilgiEkleOpen,
    setSelectedTest,
    setIstemEkleRowsStateTrigger,
    setTestIstemDetayBilgiGuncelleOpen
} = IstemPanelSlice.actions;

export default IstemPanelSlice;
